const replaceQueryParamsWithoutReload = () => {
  const newurl =
    window.location.protocol +
    '//' +
    window.location.host +
    window.location.pathname +
    window.location.hash;
  window.history.replaceState({ path: newurl }, '', newurl);
};

export const HistoryHelper = {
  replaceQueryParamsWithoutReload,
};
